import { render, staticRenderFns } from "./RomaPDF.vue?vue&type=template&id=19075be6&"
import script from "./RomaPDF.vue?vue&type=script&lang=js&"
export * from "./RomaPDF.vue?vue&type=script&lang=js&"
import style0 from "./RomaPDF.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports